import Vue from 'vue'
import {http} from '@/axios'
import $router from '@/router'
import makeNotificationSound from '@/helpers/makeNotificationSound'
import {CancelToken} from 'axios'

let cancelLoadNew;

function getInitState() {
  return {
    messages: [],
    interlocutor: null,
    me: null,
    pending: false,
    pendingLoadMore: false,
    pendingLoadNew: false,
    pendingSend: false,
    timerLoadMew: null,
    timerLoadNewDuration: 1600,
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    pushMessages(state, messages) {
      state.messages = state.messages.concat(messages)
    },
    unshiftMessages(state, messages) {
      state.messages = messages.concat(state.messages)
    },
    setReadMessages(state, ids) {
      const messages = state.messages

      for (const message of messages) {
        if(ids.includes(message.id)) {
          Vue.set(message, 'read_message', 1)

          ids.splice(ids.indexOf(message.id), 1)

          if(!ids.length) break
        }
      }
    }
  },
  actions: {
    stop({dispatch}) {
      if (cancelLoadNew) {
        cancelLoadNew()
        cancelLoadNew = null
      }

      dispatch('unSubscribeOnUpdate')
      dispatch('unSubscribeOnUpdateRead')
    },
    subscriberOnUpdate({rootState, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnUpdate')
      const channel = rootState.user.userPusher.channel
      channel.bind('update-chat', () => {
        //{"update":{"interaction_id":317,"chat_id":316}}}}
        makeNotificationSound()
        dispatch('loadNewMessages')
      })
    },
    unSubscribeOnUpdate({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('update-chat')
    },
    load({commit}, id) {
      commit('setProperty', ['pending', true])

      return http.get('/api/new-interaction/chat', {
        params: {
          interaction_id: id,
        }
      }).then(({data}) => {
        if(data.data === false) return

        let arr = data.data.chat_messages
        commit('setProperty', ['messages', arr])
        commit('setProperty', ['interlocutor', data.data.interlocutor])
        commit('setProperty', ['me', data.data.me])
      }).finally(() => {
        commit('setProperty', ['pending', false])
      })
    },
    loadMore({state, commit}, id) {
      commit('setProperty', ['pendingLoadMore', true])

      return http.get('/api/new-interaction/chat', {
        params: {
          interaction_id: id,
          chat_message_id: state.messages[0] ? state.messages[0].id : null,
          back: 1
        }
      }).then(({data}) => {
        if(data.data === false) return

        commit('unshiftMessages', data.data.chat_messages)
        commit('setProperty', ['interlocutor', data.data.interlocutor])
        commit('setProperty', ['me', data.data.me])
      }).finally(() => {
        commit('setProperty', ['pendingLoadMore', false])
      })
    },
    loadNewMessages({state, commit}) {
      commit('setProperty', ['pendingLoadNew', true])
      const interactionId = $router.currentRoute.params.id

      if (cancelLoadNew) {
        cancelLoadNew()
        cancelLoadNew = null
      }

      clearTimeout(state.timerLoadMew)

      return http.get('/api/new-interaction/chat', {
        params: {
          interaction_id: interactionId,
          chat_message_id: state.messages[0] ? state.messages[state.messages.length - 1].id : null,
          back: 0
        },
        cancelToken: new CancelToken(c => cancelLoadNew = c)
      }).then(({data}) => {
        if(data.data === false) return

        commit('pushMessages', data.data.chat_messages)
        commit('setProperty', ['interlocutor', data.data.interlocutor])
        commit('setProperty', ['me', data.data.me])
      }).finally(() => {
        commit('setProperty', ['pendingLoadNew', false])
      })
    },
    sendMessage({commit, dispatch}, sendData) {
      commit('setProperty', ['pendingSend', true])
      return http.post('/api/new-interaction/chat-send', {
        interaction_id: sendData.interaction_id,
        message: sendData.message
      }).then(async ({data}) => {
        if(data.data === false) return

        await dispatch('loadNewMessages', sendData.interaction_id) //???
      }).finally(() => {
        commit('setProperty', ['pendingSend', false])
      })
    },

    // - - - -

    setReadMessages({commit}, ids) {
      return http.patch('/api/new-interaction/chat-read', {
        interaction_id: $router.currentRoute.params.id,
        messages: ids
      }).then(() => {
        commit('setReadMessages', ids)
      })
    },
    subscriberOnUpdateRead({rootState, dispatch, commit}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnUpdateRead')

      const channel = rootState.user.userPusher.channel
      channel.bind('update-read-chat', ({update: {READ_MESSAGES}}) => {
        commit('setReadMessages', READ_MESSAGES)
      })
    },
    unSubscribeOnUpdateRead({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('update-read-chat')
    },
  }
}
